export interface IKBCatalogCategory {
    Id: string;
    DisplayName: string;
    Description: string;
    Expanded: boolean;
    EditMode: boolean;
    KBCatalogs: IKBCatalog[];
}
export interface IKBCatalog {
    Id: string;
    IdParent: string;
    Description: string;
    DisplayName: string;
    Expanded?: boolean;
    HasChanges?: boolean;
    KBArtifacts: IKBArtifact[];
}

export interface IKBArtifact {
    Id?: string;
    IdParent?: string;
    Description: string;
    DisplayName: string;
    FileName: string;
    ArtifactStatus?: string;
    Content: string;
    Extension: string;
    ArtifactStatusLocalized?: string;
    HasChanges?: boolean;
    Deleted?: boolean;
}

export enum ArtifactStatus {
    Processing = "PROCESSING",
    Available = "AVAILABLE",
    Failed = "FAILED",
    ToProcess = "TOPROCESS",
    Unknown = "UNKNOWN"
}

export interface IKBCatalogCategoryLearned {
    Id: string;
    DisplayName: string;
    Description: string;
    Expanded: boolean;
    EditMode: boolean;
    KBLearned: IKBLearned[];
}

export interface IKBLearned {
    Id: string;
    IdParent: string;
    Description: string;
    DisplayName: string;
    Expanded?: boolean;
    Frequency: string;
    StartDate: string;
    Status: string;
    StatusLocalized?: string;
}
export interface IKBLearnedEntity {
    Id: string;
    IdParent: string;
    DisplayName: string;
    Attributes: number;
    Segments: number;
    Status: string;
    StatusLocalized?: string;
    Expanded?: boolean;
}

export enum KBLearnedStatus {
    InProgress = "INPROGRESS",
    Completed = "COMPLETED",
    Failed = "FAILED",
    Delivered = "DELIVERED",
    NotExecuted = "NOTEXECUTED",
    Awaiting = "AWAITING",
    NotFound = "NOTFOUND",
    ErrorSearching = "ERRORSEARCHING"
}